import GooglePlaceFinder from "./google-place-finder.js";
import Alpine from "alpinejs";

export default class PegasusPlaceFinder {
    constructor(options) {
        this.locationLoading = false;
        this.placeFinderInput = null;
        this.geolocationInput = null;
        this.placeFinder = null;
        this.options = options;
        this.locationError = false;
        this.useMyLocation = false;
    }

    async init() {
        this.placeFinderInput = this.$refs.placeFinderInput;
        this.geolocationInput = this.$refs.geolocationInput;
        this.useMyLocation = this.options.useGeolocation === true;
        
        if (!this.options.selectionCallback) {
            this.options.selectionCallback = this.selectionCallback.bind(this);
        }
        try {
            await this.waitForGoogleMaps();
            this.placeFinder = new GooglePlaceFinder(this.placeFinderInput, this.options);
        } catch (error) {
            console.warn('Failed to initialize Google Places:', error);
        }
        
        // Handle focus event as fallback
        this.placeFinderInput.addEventListener('focus', async () => {
            if (!this.placeFinder) {
                if (typeof google !== 'undefined') {
                    this.placeFinder = new GooglePlaceFinder(this.placeFinderInput, this.options);
                } else {
                    try {
                        await this.waitForGoogleMaps();
                        this.placeFinder = new GooglePlaceFinder(this.placeFinderInput, this.options);
                    } catch (error) {
                        console.warn('Failed to initialize Google Places on focus:', error);
                    }
                }
            }
        }); 
    }

    waitForGoogleMaps(maxWaitTime = 5000) {
        return new Promise((resolve, reject) => {
            // If Google Maps is already available
            if (typeof google !== 'undefined') {
                resolve(google);
                return;
            }
            // Use MutationObserver to watch for script addition
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (node.tagName === 'SCRIPT' && node.src.includes('maps.googleapis.com')) {
                            // Wait for script to load
                            node.addEventListener('load', () => {
                                if (typeof google !== 'undefined') {
                                    observer.disconnect();
                                    resolve(google);
                                }
                            });
                        }
                    });
                });
            });
            // Start observing
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            // Timeout after maxWaitTime
            setTimeout(() => {
                observer.disconnect();
                reject(new Error('Google Maps failed to load'));
            }, maxWaitTime);
        });
    }

    selectionCallback(selected) {
        if (this.options.debug === true) {
            console.log('Selected:', selected.geometry.location.lat() + ',' + selected.geometry.location.lng())
        }
        this.geolocationInput.value = selected.geometry.location.lat() + ',' + selected.geometry.location.lng();
        if (this.options.autoSubmit === true) {
            setTimeout(() => {
                // submit the nearest form
                if (window.placeFinderSubmit !== undefined) {
                    window.placeFinderSubmit();
                } else {
                    this.$el.closest('form').submit();
                }
            }, 500);
        }
    }

    getUserLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.geolocationInput.value = position.coords.latitude + ',' + position.coords.longitude;
                    this.placeFinderInput.value = 'Your location';
                    this.locationLoading = false;
                },
                () => {
                    if (this.options.debug === true) {
                        console.log('Error when detecting location')
                    }
                    this.locationError = true;
                    this.locationLoading = false;
                }
            );
        } else {
            if (this.options.debug === true) {
                console.log('Navigator geolocation not available')
            }
            this.locationError = true;
            this.locationLoading = false;
        }
    }

    preventSubmitForm(event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();

        if (this.placeFinderInput.value === '') {
            this.geolocationInput.value = '';
        }

        if (this.options.autoSubmit !== true) {
            if (event.key === 'Enter') {
                return false;
            }
        }

        setTimeout(() => {
            // submit the nearest form
            if (window.placeFinderSubmit !== undefined) {
                window.placeFinderSubmit();
            } else {
                this.$el.closest('form').submit();
            }
        }, 500);
    }
};

Alpine.data('PegasusPlaceFinder', (options) => {return new PegasusPlaceFinder(options)});
